import { layout } from 'src/components/base';
import styled from 'styled-components';
import { Column } from '@prisjakt/ui/list/variants';
import { H3Text } from '@prisjakt/ui/text/variants';

export const GUTTER = layout.measurements.spacing100;

export const SearchResults = styled(Column)`
  padding: 0 10px;
  margin-bottom: ${GUTTER};
  margin-top: ${GUTTER};
`;

export const BodyGutter = styled.div`
  padding: 0 ${layout.measurements.spacing050};
`;

export const WrapBody = styled.div`
  margin: ${layout.measurements.spacing200} 0;
`;

export const PopularSearchesTitle = styled(H3Text)`
  text-align: left;
  padding: 0 ${layout.measurements.spacing100};
  margin: ${layout.measurements.spacing100} 0;
`;

export const BreadCrumbWrapper = styled.div`
  display: flex;
  margin: ${layout.measurements.spacing050} 0 ${layout.measurements.spacing050}
    ${layout.measurements.spacing050};
`;
